import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const MessagesContainer = styled.div`
  background: ${(props) => props.background || "rgba(0, 0, 0, 0.5)"};
  border-radius: 15px;
  padding-top: 50px;
  padding-right: 10px;
  padding-left: 10px;
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  font-family: ${(props) => props.theme.fontFamily || "inherit"}, sans-serif;
  border: 2px solid white;
  overflow: hidden;
`;

const TitleBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 10px;
  padding-left: 70px;
  background: ${(props) => props.backgroundChoice || "black"};
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  color: ${(props) => props.theme.textColor || "white"};
  z-index: 2;
  width: 100%;
  font-family: ${(props) => props.theme.fontFamily || "inherit"}, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const TitleText = styled.div`
  font-size: 1.5rem;
`;

const CircleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-height: 30px;
  gap: 0px; 
`;

const CircularSvg = styled.svg`
  width: 60px;
  height: 60px;
  transform: rotate(-90deg);
`;

const TimeLeftText = styled.span`
  font-size: 1.2rem;
  color: white;
`;

const NeonFrame = styled.div`
  width: 100%;
  padding: 20px;
  background: ${(props) => props.neonBackground || "rgba(0, 0, 0, 0.7)"};
  color: ${(props) => props.neonText || "white"};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 5px 0;
  border: 4px solid transparent;
  border-image: linear-gradient(
    90deg,
    ${(props) => props.neonColor1 || "#ff007f"},
    ${(props) => props.neonColor2 || "#00e0ff"}
  ) 1;
  font-family: ${(props) => props.fontFamily || "inherit"}, sans-serif;
`;

/* הודעת יום הולדת */
const BirthdayFrame = styled(NeonFrame)`
  background-image: url("https://img.freepik.com/premium-photo/whimsical-birthday-cake-with-lit-candles-colorful-sprinkles-against-soft-pink-background_1293074-87805.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-image: none;
  border: 3px solid transparent;
  border-radius: 10px;

  animation: neonBorder 8s infinite;

  @keyframes neonBorder {
    0% {
      box-shadow: 0 0 10px ${(props) => props.birthdayColor1 || "#ff007f"},
        0 0 20px ${(props) => props.birthdayColor1 || "#ff007f"},
        0 0 30px ${(props) => props.birthdayColor1 || "#ff007f"},
        0 0 40px ${(props) => props.birthdayColor1 || "#ff007f"};
      border-color: ${(props) => props.birthdayColor1 || "#ff007f"};
    }
    50% {
      box-shadow: 0 0 20px ${(props) => props.birthdayColor2 || "#00e0ff"},
        0 0 30px ${(props) => props.birthdayColor2 || "#00e0ff"},
        0 0 40px ${(props) => props.birthdayColor2 || "#00e0ff"},
        0 0 50px ${(props) => props.birthdayColor2 || "#00e0ff"};
      border-color: ${(props) => props.birthdayColor2 || "#00e0ff"};
    }
    100% {
      box-shadow: 0 0 10px ${(props) => props.birthdayColor1 || "#ff007f"},
        0 0 20px ${(props) => props.birthdayColor1 || "#ff007f"},
        0 0 30px ${(props) => props.birthdayColor1 || "#ff007f"},
        0 0 40px ${(props) => props.birthdayColor1 || "#ff007f"};
      border-color: ${(props) => props.birthdayColor1 || "#ff007f"};
    }
  }
`;

const MessageText = styled.p`
  font-size: 1.2em;
  text-align: center;
  margin: 0;
  color: ${(props) => props.textColor || "#ffffff"};
  font-family: ${(props) => props.theme.fontFamily || "inherit"}, sans-serif;
`;

const BirthdayText = styled.p`
  font-size: 1.2em;
  text-align: center;
  margin: 0;
  color: black;
  font-family: ${(props) => props.theme.fontFamily || "inherit"}, sans-serif;
`;


const getDynamicFontSize = (text) => {
  const wordCount = text.split(" ").length;

  if (wordCount < 20) return "1.2em";
  if (wordCount < 40) return "1.1em";
  if (wordCount < 50) return "1.0em";
  if (wordCount < 60) return "0.95em";
  if (wordCount < 70) return "0.9em";
  return "1em";
};


const MessageTicker = ({
  initialMessages,
  birthdayMessages = [],
  background,
  textColor,
  titleBackground,
  neonBackground,
  neonText,
  neonColor1,
  neonColor2,
  birthdayColor1,
  birthdayColor2,
  fontFamily,
}) => {
  
  const groupMessagesByWordCount = (messages) => {
    const groups = [];
    let currentGroup = [];
    let currentWordCount = 0;
    const totalWordCount = 70;

    messages.forEach((message) => {
      const messageWordCount = message.messageDetails.text.split(" ").length;
      if (currentWordCount + messageWordCount > totalWordCount) {
        if (currentGroup.length > 0) {
          groups.push([...currentGroup]);
          currentGroup = [];
          currentWordCount = 0;
        }
      }
      currentGroup.push(message);
      currentWordCount += messageWordCount;

      if (currentWordCount >= totalWordCount) {
        groups.push([...currentGroup]);
        currentGroup = [];
        currentWordCount = 0;
      }
    });

    if (currentGroup.length > 0) {
      groups.push(currentGroup);
    }

    return groups;
  };

  const messageGroups = groupMessagesByWordCount(initialMessages);
  const totalGroups = messageGroups.length;

  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    if (totalGroups === 0) return;

    const countdownInterval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          cycleMessages();
          return 10; 
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [totalGroups]);

  const cycleMessages = () => {
    setCurrentGroupIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;
      return nextIndex >= totalGroups ? 0 : nextIndex;
    });
  };

  const progressPercent = (timeLeft / 10) * 100;

  const radius = 10;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progressPercent / 100) * circumference;
  const currentMessages = totalGroups > 0 ? messageGroups[currentGroupIndex] : [];

  return (
    <MessagesContainer background={background} fontFamily={fontFamily}>
      <TitleBar backgroundChoice={titleBackground}>
        <CircleContainer>
          <CircularSvg>
            {/* עיגול רקע אפור */}
            <circle
              cx="30"
              cy="30"
              r={radius}
              stroke="#666"
              strokeWidth="6"
              fill="none"
            />
            {/* עיגול הצבע שממלא בהתבסס על strokeDashoffset */}
            <circle
              cx="30"
              cy="30"
              r={radius}
              stroke={neonColor1}
              strokeWidth="6"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
            />
            <TimeLeftText>{initialMessages && initialMessages.length}</TimeLeftText>
          </CircularSvg>
          <TitleText>
        {initialMessages && initialMessages.length > 0 ? `${initialMessages.length}` : ""} הודעות
        </TitleText>
        </CircleContainer>
      </TitleBar>

      {birthdayMessages.map((birthday, index) => (
        <BirthdayFrame
          key={index}
          birthdayColor1={birthdayColor1}
          birthdayColor2={birthdayColor2}
          fontFamily={fontFamily}
        >
          <BirthdayText fontFamily={fontFamily}>
            {birthday.messageDetails.greeting} 🎉
          </BirthdayText>
        </BirthdayFrame>
      ))}

      {currentMessages.map((message, index) => (
        <NeonFrame
          key={index}
          neonBackground={neonBackground}
          neonText={neonText}
          neonColor1={neonColor1}
          neonColor2={neonColor2}
          fontFamily={fontFamily}
        >
          <MessageText
            textColor={neonText || "black"}
            fontFamily={fontFamily}
            style={{ fontSize: getDynamicFontSize(message.messageDetails.text) }}
          >
            {message.messageDetails.text}
          </MessageText>
        </NeonFrame>
      ))}
    </MessagesContainer>
  );
};

MessageTicker.propTypes = {
  initialMessages: PropTypes.array.isRequired,
  birthdayMessages: PropTypes.array,
  background: PropTypes.string,
  textColor: PropTypes.string,
  titleBackground: PropTypes.string,
  neonBackground: PropTypes.string,
  neonText: PropTypes.string,
  neonColor1: PropTypes.string,
  neonColor2: PropTypes.string,
  birthdayColor1: PropTypes.string,
  birthdayColor2: PropTypes.string,
  fontFamily: PropTypes.string,
};

MessageTicker.defaultProps = {
  background: "rgba(0, 0, 0, 0.5)",
  textColor: "white",
  titleBackground: "black",
  neonBackground: "rgba(0, 0, 0, 0.7)",
  neonText: "white",
  neonColor1: "#ff007f",
  neonColor2: "#00e0ff",
  birthdayColor1: "#ff007f",
  birthdayColor2: "#00e0ff",
  fontFamily: "assistant",
};

export default MessageTicker;
